module.exports = __webpack_public_path__ + "static/img/Patrick_Dangerfield_desktop.c4ed35b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Patrick_Dangerfield_desktop.jpg
// module id = wNcT
// module chunks = 0